function getBuyerPermissions() {
    return JSON.parse(document.getElementsByTagName('html')[0].dataset.buyerPermissions) || {};
}

function canCreateOrder() {
    return getBuyerPermissions().can_create_order === true;
}

export {
    canCreateOrder,
};
